import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { DeliveryNoteOverviewState } from './delivery-note-overview.state';
import { DeliveryNoteOverview, DeliveryNoteParams } from '../../models/delivery-note.model';
import {
  DeliveryNoteOverviewInitialState,
  DeliveryNoteOverviewLoad,
  DeliveryNoteTrackingLoad,
} from './delivery-note-overview.actions';
import { DeliveryNoteHandlingUnitsFacade } from './delivery-note-handling-units/delivery-note-handling-units.facade';
import { Tracking } from '../../../../models/monitoring-tracking';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(DeliveryNoteOverviewState.getLoaded);
  tracking$: Observable<Tracking[]> = this.store.select(DeliveryNoteOverviewState.getTracking);
  overview$: Observable<DeliveryNoteOverview> = this.store.select(DeliveryNoteOverviewState.getOverview);

  constructor(private store: Store, private deliveryNoteHandlingUnitsFacade: DeliveryNoteHandlingUnitsFacade) {}
  loadAll(params: DeliveryNoteParams): void {
    this.loadTracking(params);
    this.loadOverview(params);
    this.deliveryNoteHandlingUnitsFacade.loadAll();
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNoteOverviewInitialState());
  }

  private loadOverview(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteOverviewLoad(params));
  }

  private loadTracking(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteTrackingLoad(params));
  }
}
